/* --- SHUBHAM PREMIUM CUSTOM FILTER LOGIC --- */
document.addEventListener('DOMContentLoaded', () => {
  // Setup Dropdown Toggles (Fixed to work globally)
  const triggers = document.querySelectorAll('.shubham-custom-dropdown-trigger');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault(); 
      e.stopPropagation();
      const wrapper = trigger.closest('.shubham-custom-dropdown-wrapper');
      
      // Close all other dropdowns
      document.querySelectorAll('.shubham-custom-dropdown-wrapper').forEach(w => {
        if(w !== wrapper) w.classList.remove('active');
      });
      
      wrapper.classList.toggle('active');
    });
  });

  // Close dropdowns if clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.shubham-custom-dropdown-wrapper').forEach(w => w.classList.remove('active'));
  });

  // Stop dropdown from closing when clicking inside it
  document.querySelectorAll('.shubham-custom-dropdown-content').forEach(content => {
    content.addEventListener('click', (e) => e.stopPropagation());
  });

  // Initialize slider when page loads
  shubhamInitPriceSlider();
});

/* --- GLOBAL FUNCTIONS --- */
window.shubhamClearDropdown = function(btn) {
  const content = btn.closest('.shubham-custom-dropdown-content');
  content.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
};

window.shubhamClearPrice = function() {
  const rangeMin = document.getElementById('shubham-price-min');
  const rangeMax = document.getElementById('shubham-price-max');
  if(rangeMin && rangeMax) {
    rangeMin.value = rangeMin.min;
    rangeMax.value = rangeMax.max;
    rangeMin.dispatchEvent(new Event('input'));
  }
};

window.shubhamResetAllCustomFilters = function() {
  document.querySelectorAll('.shubham-custom-dropdown-content input[type="checkbox"]').forEach(cb => cb.checked = false);
  shubhamClearPrice();
  
  const sortSelect = document.getElementById('shubham-sort-select');
  if (sortSelect) {
    sortSelect.value = 'newest';
  }
  
  shubhamApplyCustomFilters(); 
};

window.shubhamApplyCustomFilters = function(btn = null) {
  const grid = document.getElementById('shubham-product-grid');
  
  // The Safety Check
  if (!grid) {
    alert("Please note: This filter only works on pages using the Custom Shubham Trending Grid.");
    if (btn) btn.closest('.shubham-custom-dropdown-wrapper').classList.remove('active');
    return;
  }
  
  const cards = Array.from(grid.querySelectorAll('.shubham-creation-product-card'));
  
  // Get active filters
  const checkedStocks = Array.from(document.querySelectorAll('input[data-type="stock"]:checked')).map(cb => cb.value);
  const checkedSizes = Array.from(document.querySelectorAll('input[data-type="size"]:checked')).map(cb => cb.value);
  const checkedColors = Array.from(document.querySelectorAll('input[data-type="color"]:checked')).map(cb => cb.value);
  
  const minPrice = parseFloat(document.getElementById('shubham-price-min').value) || 0;
  const maxPrice = parseFloat(document.getElementById('shubham-price-max').value) || Infinity;
  
  const sortSelect = document.getElementById('shubham-sort-select');
  const sortBy = sortSelect ? sortSelect.value : 'newest';

  // Filter Cards
  cards.forEach(card => {
    let show = true;
    
    if (checkedStocks.length > 0 && !checkedStocks.includes(card.dataset.stock)) show = false;
    if (checkedSizes.length > 0 && !checkedSizes.some(size => card.dataset.sizes.includes(size))) show = false;
    if (checkedColors.length > 0 && !checkedColors.some(color => card.dataset.colors.includes(color))) show = false;
    
    const cardPrice = parseFloat(card.dataset.price);
    if (cardPrice < minPrice || cardPrice > maxPrice) show = false;

    card.style.display = show ? 'flex' : 'none';
  });

  // Sort Cards
  cards.sort((a, b) => {
    const priceA = parseFloat(a.dataset.price);
    const priceB = parseFloat(b.dataset.price);
    const dateA = parseInt(a.dataset.date);
    const dateB = parseInt(b.dataset.date);

    if (sortBy === 'price-asc') return priceA - priceB;
    if (sortBy === 'price-desc') return priceB - priceA;
    if (sortBy === 'newest') return dateB - dateA;
    if (sortBy === 'oldest') return dateA - dateB;
    return 0;
  });

  // Render updates
  cards.forEach(card => grid.appendChild(card));

  if (btn) {
    btn.closest('.shubham-custom-dropdown-wrapper').classList.remove('active');
  }
};

/* --- DUAL SLIDER LOGIC --- */
window.shubhamInitPriceSlider = function() {
  const rangeMin = document.getElementById('shubham-price-min');
  const rangeMax = document.getElementById('shubham-price-max');
  const displayMin = document.getElementById('price-min-display');
  const displayMax = document.getElementById('price-max-display');
  const rangeProgress = document.querySelector('.shubham-range-progress');

  if (!rangeMin || !rangeMax) return;

  function updateSlider() {
    let minVal = parseInt(rangeMin.value);
    let maxVal = parseInt(rangeMax.value);

    if (maxVal - minVal < 100) {
      if (this === rangeMin) {
        rangeMin.value = maxVal - 100;
        minVal = parseInt(rangeMin.value);
      } else {
        rangeMax.value = minVal + 100;
        maxVal = parseInt(rangeMax.value);
      }
    }

    displayMin.textContent = minVal;
    displayMax.textContent = maxVal;

    const percentMin = (minVal / rangeMin.max) * 100;
    const percentMax = (maxVal / rangeMax.max) * 100;
    
    rangeProgress.style.left = percentMin + "%";
    rangeProgress.style.right = (100 - percentMax) + "%";
  }

  rangeMin.addEventListener('input', updateSlider);
  rangeMax.addEventListener('input', updateSlider);
  updateSlider.call(rangeMin);
};



/* --- FIXED & PLACEHOLDER SCROLL LOGIC --- */
document.addEventListener('DOMContentLoaded', () => {
  const filterBar = document.querySelector('.shubham-premium-filter-bar');
  if (!filterBar) return;

  const siteHeader = document.querySelector('.shubham-creation-header-wrapper') || document.querySelector('header');
  
  // 1. Create an invisible placeholder to stop products from jumping
  const placeholder = document.createElement('div');
  placeholder.style.display = 'none';
  filterBar.parentNode.insertBefore(placeholder, filterBar);

  let lastScrollTop = 0;
  
  // Get initial position
  const getFilterOffset = () => filterBar.getBoundingClientRect().top + window.scrollY;
  let filterOffsetTop = getFilterOffset();

  window.addEventListener('scroll', () => {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calculate Header Height
    let headerHeight = 0;
    if (siteHeader) {
      headerHeight = siteHeader.offsetHeight;
      const annBar = document.querySelector('.shubham-creation-announcement-wrapper');
      if (annBar && currentScroll > annBar.offsetHeight) {
        headerHeight -= annBar.offsetHeight; 
      }
    }

    // Lock Point calculation
    const lockPoint = filterOffsetTop - headerHeight;

    if (currentScroll >= lockPoint) {
      // 2. Lock the filter bar & show placeholder
      filterBar.classList.add('is-fixed-active');
      placeholder.style.height = `${filterBar.offsetHeight}px`;
      placeholder.style.display = 'block';

      // 3. Move based on scroll direction
      if (currentScroll > lastScrollTop) {
        // Scrolling DOWN: Pin to absolute top (0px)
        filterBar.style.top = '0px';
      } else {
        // Scrolling UP: Sit right below the sliding header
        filterBar.style.top = `${headerHeight}px`;
      }
    } else {
      // 4. We are back at the top: Reset everything to normal
      filterBar.classList.remove('is-fixed-active');
      filterBar.style.top = 'auto';
      placeholder.style.display = 'none';
      
      // Recalculate offset gently if needed
      if (currentScroll < 10) {
        filterOffsetTop = getFilterOffset();
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }, { passive: true });
});